import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated/$tenantSlug/_layout/tool/_layout/tracking/_layout")({
    component: ToolTrackingLayout,
    loader: ({ context: { t } }) => {
        return {
            breadcrumb: t("pages.tool.tracking.title"),
        };
    },
});

function ToolTrackingLayout() {
    return <Outlet />;
}
